import { render, staticRenderFns } from "./AgreementTaiko.vue?vue&type=template&id=71d9ba78&scoped=true&"
import script from "./AgreementTaiko.vue?vue&type=script&lang=ts&"
export * from "./AgreementTaiko.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementTaiko.vue?vue&type=style&index=0&id=71d9ba78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d9ba78",
  null
  
)

export default component.exports